/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import * as _ from 'lodash'
import { isIOS, isMobile } from 'react-device-detect'
import { ListView } from 'antd-mobile'
import { ListViewProps } from 'antd-mobile/lib/list-view'
import PageLoading from '@components/PageLoading'
import RefreshIco from '@assets/images/icon/etc_icon/refresh-ico.png'
// css
import { DropdownWrap, LoadingStyle } from '@styles/base.style'
import { BettingHistoryStore, BettingRecordSource } from '@store/bettingHistoryStore'
import useRootStore from '@store/useRootStore'
import PickSalePopup from '@views/Popup/PickSale'
import { AdvEmpty } from '@components/AdvEmpty'
import { BET_HISTORY_CLUB_ALL, BETTING_HISTORY_TAB_KEY, EMPTY_ICON } from '@constants/index'
import { Select } from 'antd'
import { CircleDownIco } from '@shared/Icon/ArrowIcon'
import BottomLoading from '@components/BottomLoading'
import { CLUB_MEMBERSHIP_ID } from 'adv-protocol/src/GameCommon'
import { Button, ButtonWrap, PopupBtnStyle } from '@styles/button.style'
import { observer } from 'mobx-react'
import { GlobalStore } from '@store/globalStore'
import { BetHistoryWrap, BettingHistoryOptionWrapStyle } from './index.style'
import BettingHistoryListItem from '../BettingHistoryListItem'
import { PAGE_TYPE } from '@interface/common'
import { ClubStore } from '@store/clubStore'
import { AuthStore } from '@store/authStore'
import { FROM_VIEW_TYPE } from '@v2/constants/common'
import { ComponentStore } from '@store/componentStore'
import DialogUtils from '@utils/dialog-utils'

const CircleDown = (
  <span className="circle-down-ico">
    <CircleDownIco/>
  </span>
)

// const CLUB_LIST_TYPE = {
//   MEMBERSHIP: 0,
//   FREE: 1,
// }

interface BettingHistoryListProps {
  currentTabKey: BETTING_HISTORY_TAB_KEY
  binGameType: number
  isFullModal?: boolean
  isDeleteAllConfirmOpen: boolean
  deleteBettorBetIdsCount: number
  showBettingListItemSelectBtn: boolean
  bettingHistoryStore: BettingHistoryStore
  globalStore: GlobalStore
  clubStore: ClubStore
  authStore: AuthStore
  componentStore: ComponentStore
  fetchItems?: (
    currentTabKey: BETTING_HISTORY_TAB_KEY,
    size: number,
    clubId: string,
    pageType: PAGE_TYPE,
    resetForce: boolean,
    onlyMajorClub?: boolean,
  ) => Promise<BettingRecordSource>
  fetchSpecialItems?: (size: number, resetForce: boolean, binGameType: number) => Promise<BettingRecordSource>
  pageType?: PAGE_TYPE
  onlyMajorClub?: boolean
  fromViewType?: FROM_VIEW_TYPE
}

interface BettingHistoryListState {
  // antd-mobile의 ListView.DataSource 가 any로 설정되어 있어서 어쩔수 없이 any로 한다.
  dataSource: any
  isLoading: boolean
  hasMore: boolean
  clubId: string
}

const PAGE_SIZE = 20
// const RenderRow = (rowData, sectionID, rowID, onNeedFetch) => {
//   return <BettingHistoryListItem track={rowData} idx={rowID} onNeedFetch={this.onNeedFetch} />
// }

function getEmptyPage(isLoading: boolean) {
  return <div css={LoadingStyle}>{isLoading ? <PageLoading/> : <Fragment/>}</div>
}

function MyBody(props: any) {
  const { children } = props
  return <div className="am-list-body my-body">{children}</div>
}

let timer = null

class BettingHistoryList extends React.PureComponent<BettingHistoryListProps, BettingHistoryListState> {
  private mounted = false

  private lastTabKey = BETTING_HISTORY_TAB_KEY.ONGOING

  private rowData = []

  constructor(props) {
    super(props)

    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    })

    this.state = {
      dataSource,
      isLoading: false,
      hasMore: false,
      clubId: BET_HISTORY_CLUB_ALL,
    }
  }

  RenderRow = (rowData, sectionID, rowID) => {
    return <BettingHistoryListItem
      currentTabKey={this.props.currentTabKey}
      track={rowData}
      idx={rowID}
      onNeedFetch={this.onNeedFetch}
      onClickBettingStorage={this.onClickBettingStorage}
      fetchItems={this.fetch}
      pageType={this.props.pageType}
      fromViewType={this.props.fromViewType}
    />
  }

  componentDidUpdate(prevProps: Readonly<BettingHistoryListProps>): void {
    if (prevProps.binGameType !== this.props.binGameType) {
      this.fetch(true)
    }
  }

  removeRowData = (bettorBetId: string) => {
    this.rowData = this.rowData.filter(data => data.betId !== bettorBetId)
    this.updateRowData()
  }

  onClickBettingStorage = (bettorBetId: string) => {
    this.removeRowData(bettorBetId)
  }

  onClickCancelDeleteBet = () => {
    const { bettingHistoryStore, fromViewType } = this.props
    bettingHistoryStore.setIsDeleteAllConfirmOpenByView(false, fromViewType)
    bettingHistoryStore.clearBettorBetIdsByFromViewType(fromViewType)
  }

  onClickDeleteBet = async () => {
    const { bettingHistoryStore, fromViewType } = this.props
    const deleted = await bettingHistoryStore.fetchDeleteBet(fromViewType)
    if (deleted) {
      const { deleteBettorBetIds } = bettingHistoryStore
      deleteBettorBetIds[`${fromViewType}`].forEach(bettorBetId => this.removeRowData(bettorBetId))
      bettingHistoryStore.clearBettorBetIdsByFromViewType(fromViewType)
      bettingHistoryStore.setIsDeleteAllConfirmOpenByView(false, fromViewType)
    }
  }

  onClickDeleteAllBet = async () => {
    DialogUtils.showBettingHistoryAllDelete(async () => {
      const { bettingHistoryStore, fromViewType } = this.props
      bettingHistoryStore.setIsDeleteAllConfirmOpenByView(false, fromViewType)
      this.setState({
        isLoading: true,
        dataSource: this.state.dataSource.cloneWithRows([]),
        hasMore: false,
      })
      try {
        const { bettingHistoryStore } = this.props
        const { clubId } = this.state
        const params = { clubId }
        if (clubId === BET_HISTORY_CLUB_ALL) {
          params.clubId = null
        }
        const deleted = await bettingHistoryStore.fetchDeleteAllBet(params)
        if (deleted) {
          bettingHistoryStore.clearBettorBetIdsByFromViewType(fromViewType)
          bettingHistoryStore.setIsDeleteAllConfirmOpenByView(false, fromViewType)
          await this.fetch(true, clubId)
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.setState({ isLoading: false })
      }
    })
  }

  updateRowData = () => {
    const { dataSource } = this.state
    const rows = { ...this.rowData }
    const newSource = dataSource.cloneWithRows(rows)

    this.setState({
      dataSource: newSource,
    })
  }

  componentDidMount() {
    const { currentTabKey, authStore, bettingHistoryStore, fromViewType } = this.props
    this.lastTabKey = currentTabKey
    this.mounted = true

    bettingHistoryStore.clearBettorBetIdsByFromViewType(fromViewType)
    bettingHistoryStore.setIsDeleteAllConfirmOpenByView(false, fromViewType)

    if (authStore.isSignedIn) {
      authStore.refreshSimpleUserInfo(true)
      // 불필요한 조회 제거.
      // clubStore.fetch({})
    }

    clearTimeout(timer)
    timer = setTimeout(async () => {
      await this.fetch(true)
    }, 500)
  }

  resetListDataSource = (): void => {
    const { dataSource } = this.state
    const newSource = dataSource.cloneWithRows([])
    this.rowData = []
    this.setState({
      dataSource: newSource,
      isLoading: true,
    })
  }

  fetch = async (reset = false, clubId = BET_HISTORY_CLUB_ALL) => {
    const { dataSource, isLoading, hasMore } = this.state
    const {
      currentTabKey,
      binGameType,
      fetchItems,
      fetchSpecialItems,
      pageType,
      onlyMajorClub,
    } = this.props

    if (reset) {
      const newSource = dataSource.cloneWithRows([])
      this.rowData = []
      this.setState({
        dataSource: newSource,
        hasMore: false,
        clubId,
      })
    } else {
      if (isLoading || !hasMore) {
        return
      }

      this.setState({ isLoading: true })
    }

    let fetched: BettingRecordSource
    if (currentTabKey === BETTING_HISTORY_TAB_KEY.SPECIAL) {
      fetched = await fetchSpecialItems(PAGE_SIZE, reset, binGameType)
    } else {
      fetched = await fetchItems(
        currentTabKey, PAGE_SIZE, clubId, pageType, reset, onlyMajorClub,
      )
    }

    if (fetched) {
      if (this.lastTabKey !== fetched.currentTabKey) {
        return
      }

      if (reset) {
        this.rowData = []
      }

      this.rowData = _.concat(this.rowData, fetched.lastFetched || [])
      const rows = { ...this.rowData }
      const newSource = dataSource.cloneWithRows(rows)

      // TEST: loading test
      // await delay(250)

      this.setState({
        isLoading: false,
        dataSource: newSource,
        hasMore: fetched.hasMore,
      })
    } else {
      this.setState({
        isLoading: false,
        dataSource: dataSource.cloneWithRows([]),
        hasMore: false,
      })
    }
  }

  onNeedFetch = async event => {
    const { clubId } = this.state
    await this.fetch(true, clubId)
  }

  onEndReached = async event => {
    const { clubId } = this.state
    await this.fetch(false, clubId)
  }

  renderFooter = () => {
    const { isLoading } = this.state
    const { rowData } = this
    let footer = null
    if (isLoading) {
      footer = <BottomLoading/>
    } else if (rowData.length > 0) {
      footer = <Fragment/>
    } else if (this.props.currentTabKey === BETTING_HISTORY_TAB_KEY.SHARED) {
      footer = <AdvEmpty ico={EMPTY_ICON.BET_SHARED}/>
    } else if (this.props.currentTabKey === BETTING_HISTORY_TAB_KEY.SAVED) {
      footer = <AdvEmpty ico={EMPTY_ICON.BET_KEEP}/>
    } else if (this.props.pageType === PAGE_TYPE.USER_PICK_DETAIL) {
      footer = <AdvEmpty ico={EMPTY_ICON.USER_PICK_INDIVIDUAL_MATCH}/>
    } else if (this.props.pageType === PAGE_TYPE.MATCHUP_DETAIL_PICK) {
      footer = <AdvEmpty ico={EMPTY_ICON.MATCHUP_DETAIL_INDIVIDUAL_MATCH}/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.BET_HISTORY}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  onClubChange = (clubId: string) => {
    this.setState({ clubId })
    this.fetch(true, clubId)
  }

  render() {
    const { dataSource, clubId, isLoading } = this.state
    const {
      currentTabKey,
      isFullModal,
      isDeleteAllConfirmOpen,
      deleteBettorBetIdsCount,
      showBettingListItemSelectBtn,
      pageType,
      globalStore,
      clubStore,
      authStore,
      componentStore,
    } = this.props
    const { lastTabKey } = this
    this.lastTabKey = currentTabKey
    let needFetch = false
    let refreshButtonClassName = 'refresh-btn'
    if (!isDeleteAllConfirmOpen && !showBettingListItemSelectBtn) {
      refreshButtonClassName = refreshButtonClassName.concat(' disabled')
    }
    if (!isMobile) {
      refreshButtonClassName = refreshButtonClassName.concat(' pc')
    }
    if (isFullModal) {
      refreshButtonClassName = refreshButtonClassName.concat(' full-modal')
    }

    const deleteButtonClassName = deleteBettorBetIdsCount > 0 ?
      'three-button bottom-btn delete' :
      'three-button bottom-btn delete disabled'

    if (currentTabKey !== lastTabKey) {
      needFetch = true
    }

    if (this.mounted === false) {
      return getEmptyPage(true)
    }

    if (needFetch) {
      this.resetListDataSource()
      clearTimeout(timer)
      timer = setTimeout(async () => {
        await this.fetch(true, clubId)
      }, 500)
    }

    // TODO: 복수개의 ListView 의 페이지 끝 도달 이벤트가 처리되어 아래와 같이 예외 처리 추가! 근본적 해결책은?
    const endReachedHandler = this.onEndReached
    const listViewProps: ListViewProps = {
      dataSource,
      renderFooter: this.renderFooter,
      renderRow: this.RenderRow,
      className: 'am-list',
      pageSize: PAGE_SIZE,
      initialListSize: PAGE_SIZE,
      useBodyScroll: (isMobile && !isFullModal), // PC 일때 false, 모바일이면서 fullModal 이면 false, 그외엔 true (모달창 내부에 listView 를 사용할 일이 있다면... 고려할것.)
      renderBodyComponent: () => <MyBody/>,
      scrollRenderAheadDistance: 500,
      onEndReached: endReachedHandler,
      onEndReachedThreshold: 10,
    }

    if (isMobile) {
      delete listViewProps.renderBodyComponent
    }

    const { Option } = Select

    const { simpleClubs } = clubStore
    const { isSpecificClubMember } = authStore
    const joinedClubs = _.filter(simpleClubs, club => {
      return club.isMember && club.grade !== CLUB_MEMBERSHIP_ID.FREE
    })
    console.log('========== joinedClubs', joinedClubs)
    let wrapClassName
    const isBanner = currentTabKey === BETTING_HISTORY_TAB_KEY.ONGOING
      && (!isFullModal || globalStore.visibleBubbleBetList)
      && !globalStore.showBettingListItemSelectBtn
      && pageType !== PAGE_TYPE.USER_PICK

    if (isBanner && componentStore.bettingHistoryBanner) {
      wrapClassName = 'betting-history-wrap'
    } else {
      wrapClassName = 'betting-history-wrap no-banner'
    }

    if (isMobile) {
      if (isFullModal) {
        wrapClassName += ' full-modal'
      }
      if (isDeleteAllConfirmOpen) {
        wrapClassName += ' m-delete-mode'
      }
    } else {
      wrapClassName += ' pc'
      if (isDeleteAllConfirmOpen) {
        wrapClassName += ' pc-delete-mode'
      }
    }

    const onClickRefreshBetList = () => {
      if (!isLoading && (!isDeleteAllConfirmOpen || showBettingListItemSelectBtn)) {
        this.resetListDataSource()
        clearTimeout(timer)
        timer = setTimeout(async () => {
          await this.fetch(true, clubId)
        }, 500)
      }
    }

    const fromUserPick = () => {
      return pageType === PAGE_TYPE.USER_PICK || pageType === PAGE_TYPE.USER_PICK_DETAIL
        || pageType === PAGE_TYPE.MATCHUP_DETAIL_PICK
    }

    return (
      <Fragment>
        <div css={BettingHistoryOptionWrapStyle}>
          {/* TODO 삭제모드일 경우 <Button>에 'disabled' className을 추가해주시면 됩니다. */}
          <Button onClick={onClickRefreshBetList} className={refreshButtonClassName}>
            <img src={RefreshIco} alt="새로고침" className="refresh-ico"/>
          </Button>

          {!isSpecificClubMember
            && currentTabKey !== BETTING_HISTORY_TAB_KEY.SHARED
            && !fromUserPick()
            && (
              <DropdownWrap id="betting-history-select-parent" className="betting-history">
                <Select
                  defaultValue={BET_HISTORY_CLUB_ALL}
                  className="club-select"
                  onChange={this.onClubChange}
                  getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                >
                  <Option key={'betting-history-club:all'} value={BET_HISTORY_CLUB_ALL}>
                    <span className="option-txt">전체클럽</span>
                  </Option>
                  {_.map(joinedClubs, club => {
                    const clubKey = `betting-history-club:${club.id}`
                    return (
                      <Option key={clubKey} value={club.id}>
                        <span className="option-txt">{club.name}</span>
                      </Option>
                    )
                  })}
                </Select>
                {CircleDown}
              </DropdownWrap>
            )}
        </div>

        <BetHistoryWrap id="betHistoryWrap" className={wrapClassName}>

          <ListView {...listViewProps}/>

        </BetHistoryWrap>

        {/* TODO 베팅 삭제 활성화 상태일 때만 호출되어야 합니다. */}
        {/* TODO 선택 활성화 상태일 경우 채팅 아이콘이 노출되지 않아야 합니다. */}
        {isDeleteAllConfirmOpen && (
          <ButtonWrap
            className={
              isMobile
                ? isIOS
                  ? 'full-modal button-wrap page-btn-wrap ios'
                  : 'full-modal button-wrap page-btn-wrap'
                : 'full-modal button-wrap'
            }>
            <Button css={PopupBtnStyle} className="three-button cancel bottom-btn"
                    onClick={this.onClickCancelDeleteBet}>
              취소
            </Button>
            <Button css={PopupBtnStyle} className="three-button all-delete bottom-btn"
                    onClick={this.onClickDeleteAllBet}>
              전체삭제
            </Button>
            {/* 삭제버튼이 비활설화될 경우 'disabled' className을 추가해주셔야합니다. */}
            <Button css={PopupBtnStyle} className={deleteButtonClassName} onClick={this.onClickDeleteBet}>
              삭제
            </Button>
          </ButtonWrap>
        )}

        {/* ********** 픽판매 modal *********** */}
        {currentTabKey === BETTING_HISTORY_TAB_KEY.ONGOING && <PickSalePopup/>}
      </Fragment>
    )
  }
}

interface WrapperProps {
  currentTabKey: BETTING_HISTORY_TAB_KEY
  binGameType?: number
  isFullModal?: boolean
  pageType?: PAGE_TYPE
  onlyMajorClub?: boolean
  fromViewType?: FROM_VIEW_TYPE
}

const Wrapper: React.FC<WrapperProps> = (props: WrapperProps) => {
  const { bettingHistoryStore, globalStore, clubStore, authStore, componentStore } = useRootStore()
  const { isDeleteAllConfirmOpenByView, deleteBettorBetIdsCount } = bettingHistoryStore
  const { showBettingListItemSelectBtn } = globalStore
  const { currentTabKey, binGameType, isFullModal, pageType, onlyMajorClub, fromViewType } = props

  const listProps = {
    currentTabKey,
    binGameType,
    isFullModal,
    isDeleteAllConfirmOpen: isDeleteAllConfirmOpenByView[fromViewType],
    deleteBettorBetIdsCount: deleteBettorBetIdsCount[fromViewType],
    bettingHistoryStore,
    showBettingListItemSelectBtn,
    globalStore,
    clubStore,
    authStore,
    componentStore,
    fetchItems: bettingHistoryStore.fetchItems,
    fetchSpecialItems: bettingHistoryStore.fetchSpecialItems,
    pageType,
    onlyMajorClub,
    fromViewType,
  }

  console.log('!==== Wrapper')

  return <BettingHistoryList {...listProps} />
}

export default observer(Wrapper)
